import { SpanInput } from "./SpanInput";

export default SpanInput;
